/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { View } from '@az/starc-ui'
import { PropsWithChildren } from 'react'

interface Props extends PropsWithChildren {
  id?: string
  onSubmit?: (e: React.FormEvent) => void
  gap?: number
}

export const InputForm = ({ id, children, gap, onSubmit }: Props) => {
  return (
    <form
      id={id}
      onSubmit={e => {
        e.preventDefault()
        onSubmit?.(e)
      }}
    >
      <View direction="column" gap={gap == undefined ? 6 : gap}>
        {children}
      </View>
    </form>
  )
}
